const RoomRates = ({
    isEditMode,
    roomRows,
    updateRoomRow,
    mealplan,
    ratecode,
    Pms,
    nights,
    handleEdit,
    handleRoomDone,
    handleCancel,
    totalAmount,
    totalTaxAmount,
    totalRowAmount,
    totalPayment,
    totalTax,
    grandTotal,
}) => {
    return (
        <div className="card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <span className="material-symbols-outlined me-2 text-primary">king_bed</span>
                    Room &amp; Rates
                </div>
                {!isEditMode ? (
                    <button type="button" className="btn btn-sm btn-primary" onClick={handleEdit}>Edit</button>
                ) : (
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-sm btn-success" onClick={handleRoomDone}>Done</button>
                        <button type="button" className="btn btn-sm btn-secondary" onClick={handleCancel}>Cancel</button>
                    </div>
                )}
            </div>

            <div className="table-responsive">
                <table className="table align-middle mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: "250px" }}>Room Type</th>
                            <th style={{ width: "170px" }}>Meal Plan</th>
                            {Pms?.PMS === "Opera" && (<th style={{ width: "170px" }}>Rate Plan</th>)}
                            <th className="text-center">Adults</th>
                            <th className="text-center">Child</th>
                            <th className="text-center">Extra Bed</th>
                            <th className="text-center" style={{ width: "120px" }}>Amount</th>
                            <th className="text-center" style={{ width: "90px" }}>Tax (%)</th>
                            <th className="text-center">Tax Rate</th>
                            <th className="text-end">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {roomRows.map((row, index) => (
                            <tr key={index}>
                                <td className="ps-4 fw-bold">{row.RoomName}</td>

                                {/* Meal Plan */}
                                <td>
                                    {isEditMode ? (
                                        <select className="form-select" value={row.mealPlanID}
                                            onChange={(e) => updateRoomRow(index, "mealPlanID", e.target.value)}>
                                            <option value="">Select Meal Plan</option>
                                            {mealplan?.map((item) => (
                                                <option key={item.MealPlanID} value={item.Code}>{item.Name}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <span>{row.mealPlanID || "-"}</span>
                                    )}
                                </td>

                                {/* Rate Plan (Opera only) */}
                                {Pms?.PMS === "Opera" && (
                                    <td>
                                        {isEditMode ? (
                                            <select className="form-select" value={row.ratePlanID}
                                                onChange={(e) => updateRoomRow(index, "ratePlanID", e.target.value)}>
                                                <option value="">Select Rate Plan</option>
                                                {ratecode?.map((item) => (
                                                    <option key={item.RateCodeID} value={item.Code}>{item.Name}</option>
                                                ))}
                                            </select>
                                        ) : (
                                            <span>{ratecode?.find((item) => item.Code === row.ratePlanID)?.Name || "-"}</span>
                                        )}
                                    </td>
                                )}

                                {/* Adults */}
                                <td className="text-center">
                                    {isEditMode ? (
                                        <div className="btn-group btn-group-sm d-flex align-items-center justify-content-center">
                                            <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                                onClick={() => updateRoomRow(index, "adults", Math.max(1, row.adults - 1))}>
                                                <i className="fas fa-minus"></i>
                                            </button>
                                            <span className="px-3 fw-bold">{row.adults}</span>
                                            <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                                onClick={() => updateRoomRow(index, "adults", row.adults + 1)}>
                                                <i className="fas fa-plus"></i>
                                            </button>
                                        </div>
                                    ) : (
                                        <span className="fw-bold">{row.adults}</span>
                                    )}
                                </td>

                                {/* Child */}
                                <td className="text-center">
                                    {isEditMode ? (
                                        <div className="btn-group btn-group-sm d-flex align-items-center justify-content-center">
                                            <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                                onClick={() => updateRoomRow(index, "child", Math.max(0, row.child - 1))}>
                                                <i className="fas fa-minus"></i>
                                            </button>
                                            <span className="px-3 fw-bold">{row.child}</span>
                                            <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                                onClick={() => updateRoomRow(index, "child", row.child + 1)}>
                                                <i className="fas fa-plus"></i>
                                            </button>
                                        </div>
                                    ) : (
                                        <span>{row.child}</span>
                                    )}
                                </td>

                                {/* Extra Bed */}
                                <td className="text-center">
                                    {isEditMode ? (
                                        <div className="btn-group btn-group-sm d-flex align-items-center justify-content-center">
                                            <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                                onClick={() => updateRoomRow(index, "extraBed", Math.max(0, row.extraBed - 1))}>
                                                <i className="fas fa-minus"></i>
                                            </button>
                                            <span className="px-3 fw-bold">{row.extraBed}</span>
                                            <button className="btn btn-light border btn-sm py-0 px-1" type="button"
                                                onClick={() => updateRoomRow(index, "extraBed", row.extraBed + 1)}>
                                                <i className="fas fa-plus"></i>
                                            </button>
                                        </div>
                                    ) : (
                                        <span>{row.extraBed}</span>
                                    )}
                                </td>

                                {/* Amount */}
                                <td className="text-end">
                                    {isEditMode ? (
                                        <input className="form-control" type="number" value={row.amount}
                                            onChange={(e) => updateRoomRow(index, "amount", e.target.value)} />
                                    ) : (
                                        <span>{row.amount}</span>
                                    )}
                                </td>

                                {/* Tax % */}
                                <td className="text-end">
                                    {isEditMode ? (
                                        <select className="form-select" value={row.tax}
                                            onChange={(e) => updateRoomRow(index, "tax", e.target.value)}>
                                            <option value="">Select</option>
                                            <option value="5">5%</option>
                                            <option value="18">18%</option>
                                        </select>
                                    ) : (
                                        <span>{row.tax}%</span>
                                    )}
                                </td>

                                <td className="text-end text-muted small fw-bold">{row.taxRate}</td>
                                <td className="text-end pe-4 fw-bold text-primary ">{row.total}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            {Pms?.PMS === "Opera" && <td></td>}
                            <td colSpan={5} className="text-end fw-bold">Total -</td>
                            <td className="text-end fw-bold">{totalAmount.toFixed(2)}</td>
                            <td></td>
                            <td className="text-end fw-bold">{totalTaxAmount.toFixed(2)}</td>
                            <td className="text-end pe-4 fw-bold">{totalRowAmount.toFixed(2)}</td>
                        </tr>
                        <tr>
                            {Pms?.PMS === "Opera" && <td></td>}
                            <td colSpan={5} className="text-end fw-bold">Grand Total -</td>
                            <td className="text-end fw-bold">{totalPayment.toFixed(2)}</td>
                            <td></td>
                            <td className="text-end fw-bold">{totalTax.toFixed(2)}</td>
                            <td className="text-end pe-4 fw-bold">{grandTotal.toFixed(2)}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default RoomRates;